export default "__VITE_ASSET__ClInPHUU__"